import { ENERGY_REGEN_MS } from '../balance.js';
import type { GameEvent } from '../events.js';
import type { BotUser } from '../state.js';

/**
 * `rpg/adventures/energy.ts#powerRegenerate`: +1 per whole 10 minutes,
 * `last` advanced in whole steps; at full energy `last` follows `now`.
 */
export function regenerateEnergy(save: BotUser, now: number, events: GameEvent[]): void {
  const energy = save.adventures.energy;
  if (energy.current < energy.max) {
    const restore = Math.floor((now - energy.last) / ENERGY_REGEN_MS);
    if (restore > 0) {
      const before = energy.current;
      energy.current = Math.min(energy.max, energy.current + restore);
      energy.last += restore * ENERGY_REGEN_MS;
      events.push({ type: 'energyRegenerated', amount: energy.current - before });
    }
  } else {
    energy.last = now;
  }
}

/** `nextEnergyTimestamp`: epoch ms of the next +1, or null when full. */
export function nextEnergyAt(save: BotUser, now: number): number | null {
  const energy = save.adventures.energy;
  if (energy.current >= energy.max) return null;
  const intervals = Math.floor(Math.max(0, now - energy.last) / ENERGY_REGEN_MS);
  return energy.last + (intervals + 1) * ENERGY_REGEN_MS;
}
